<template>
    <div class="online_quitting" v-loading="loading">
        <div class="online_quitting_box">            
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>> 法律咨询 >在线咨询
            </div>
            <div class="chat_box">
                <div class="chat">
                    <div class="cat_title_flex">
                        <div class="titles">
                            在线咨询
                        </div>
                    </div>
                    <div class="textarea_box">
                        <textarea name="" id="" maxlength="500" placeholder="现非工作时间，可先留下你的疑问。" v-model="texts" ></textarea>
                    </div>
                    <div class="img_list">
                        <div class="imgs" v-for="(item,index) in img_list" :key="index">
                            <img :src="item" alt="" class="imgs1"> 
                            <img src="@/assets/img/login/clear.png" alt="" class="imgs2" @click="handle_clear(index)"> 
                        </div>
                        <div class="imgs_add" @click="handle_img_add">
                            <div class="img_add_img">
                                <img src="../../assets/img/index/legal/add_img.png" alt=""> 
                            </div>
                            <div class="add_text">添加图片</div>
                        </div>
                    </div>
                    <div class="chat_nums">
                        <div class="nums_text">请描述您的问题（0-500字）</div>
                    </div>
                    <div class="btns_flex">
                        <div class="nums_text">{{ texts.length }}/500</div>
                        <div class="btns" @click="handle_end">提交</div>
                    </div>
                </div>
                <div class="chat_flex">
                    <div class="btns1">法律裁判点评网</div>
                    <div class="btns1">已有 <span>{{ userNum }}</span> 人提出问题</div>
                    <div class="btns1">律师已解答：<span>{{ lawyerNum }}</span> 问题</div>
                </div>
            </div>
        </div>
        <online_success ref="online_success"></online_success>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>


    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import online_success from '@/components/legal_advice/online_success.vue'//提交成功

import upload from '@/components/upload/upload.vue'


export default {
    components: {
        online_success,
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            loading: false,
            texts:'',
            img_list:[],
            userNum:'',
            lawyerNum:'',
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_data()
    },
    methods: {
        get_data(){
            this.loading=true
            this.$api("leaveData", {
            
			}, "get").then((res) => {
                this.loading = false
                console.log('咨询数量',res)
                if (res.code == 1) {
                    this.userNum=res.data.userNum//用户提问总数
                    this.lawyerNum=res.data.lawyerNum//律师答复总数
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_clear(index){
            console.log('img_list',this.img_list)
            this.img_list.splice(index,1)
        },
        //触发上传
        handle_img_add(){
            let datas={
                
            }
            this.$refs.uploads.uploadFile(datas)
        },
         //上传图片
         upload_url(res_data,datas){
            this.img_list.push(res_data.path)
        },
        //删除图片
        // handle_clear(index,text){
        //     this[text].splice(index,1)
        // },
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        change_banner(e){
            // console.log('却换触发',e)
            this.banner_ac=e
        },
        handle_end(){
            if(!this.texts){
                alertErr('请输入描述')
                return
            }
            if(this.img_list.length==0){
                alertErr('请上传图片')
                return
            }
            this.loading=true
            this.$api("leaveMsgAppoint", {
                content:this.texts,
                images:this.img_list.join(',')
			}, "post").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {
                    this.$refs.online_success.handle_open()
                } else {
                    alertErr(res.msg)
                }
            });
        },

    },

}
</script>
<style scoped lang="less">
.online_quitting {
    width: 100%;
    // height: 900px;
    padding-bottom: 200px;
    background-color: #F5F5F5;
    .online_quitting_box{
        width: 1440px;
        height: 100%;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .chat_box{
            width: 960px;
            height: 560px;
            // background: #FFFFFF;
            // box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            // border-radius: 20px 20px 20px 20px;
            margin: auto;
            .chat{
                width: 960px;
                height: 560px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                .cat_title_flex{
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    border-bottom: 1px solid #E8E8E8;
                    height: 50px;
                    padding: 0 32px;

                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        // line-height: 50px;
                        display: flex;
                        align-items: center;
                        img{
                            width: 17px;
                            height: 17px;
                            margin-right: 8px;
                        }
                    }
                   
                }
                .textarea_box{
                    padding:15px 32px;
                    height: 300px;
                    textarea{
                        width: 100%;
                        height: 100%;
                    }
                }
                .img_list{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 0 32px;
                    .imgs{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px solid rgba(0,0,0,0.15);
                        margin-right: 10px;
                        position: relative;
                        .imgs1{
                            width: 100%;
                            height: 100%;
                        }
                        .imgs2{
                            position: absolute;
                            right: 0;
                            top: 0;
                            cursor: pointer;
                            width: 20px;
                            height: 20px;
                        }
                    }
                    .imgs_add{
                        width: 70px;
                        height: 70px;
                        background: rgba(206,206,206,0.04);
                        border: 1px dashed  rgba(0,0,0,0.15);
                        cursor: pointer;
                        padding-top: 16px;
                        .img_add_img{
                            width: 22px;
                            height: 22px;
                            border: 1px dashed  rgba(0,0,0,0.15);
                            margin: auto;
                            display: flex;
                            align-items: center;
                            img{
                                width: 22px;
                                height: 22px;
                            }
                        }
                        .add_text{
                            padding-top: 5px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 9px;
                            color: #878787;
                            text-align: center;
                        }
                    }
                }
                .chat_nums{
                    width: 960px;
                    height: 36px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 16px;
                    padding: 0 32px;
                    .nums_text{
                        line-height: 36px; 
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9C9EA0;

                    }
                }
                .btns_flex{
                    display: flex;
                    align-items: end;
                    justify-content: end;
                    // align-content: end;
                    padding: 0 32px;
                    padding-top: 28px;
                    .nums_text{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-right: 24px;
                    }
                    .btns{
                        width: 80px;
                        height: 36px;
                        background: #377CFD;
                        border-radius: 6px 6px 6px 6px;
                        text-align: center;
                        line-height: 36px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        cursor: pointer;
                    }
                }
            }
            .chat_flex{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 40px;
                padding-top: 32px;
                .btns1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    span{
                        color: #377CFD;
                    }
                }

            }
        }
    }
}
</style>